"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchApplicationsCommand = void 0;
const SearchEngineFactory_1 = require("./search/SearchEngineFactory");
const AbstractFilteredApplicationsCommand_1 = require("./AbstractFilteredApplicationsCommand");
class SearchApplicationsCommand extends AbstractFilteredApplicationsCommand_1.AbstractFilteredApplicationsCommand {
    constructor() {
        super(...arguments);
        this.pageSize = SearchApplicationsCommand.DEFAULT_PAGE_SIZE;
        this.withPageSize = (pageSize) => {
            this.pageSize = pageSize;
            return this;
        };
        this.page = (pageNumber) => {
            this.filter.page = pageNumber;
            return this;
        };
        this.exec = async () => {
            return SearchEngineFactory_1.SearchEngineFactory.produce(this.filter).execute(this.api, this.filter.page || 0, this.pageSize);
        };
    }
}
exports.SearchApplicationsCommand = SearchApplicationsCommand;
SearchApplicationsCommand.DEFAULT_PAGE_SIZE = 10;
//# sourceMappingURL=SearchApplicationsCommand.js.map